import { HttpKyClient } from '@/shared/http/ky.adapter';
import { ENDPOINT, type Response } from '../types/get-payment-ways';
import { HttpMethod } from '@/shared/contracts/http-client.contract';

export type UseCaseInput = {
  store_slug: string;
};

export type UseCaseOutput = Response;

export class GetPaymentWaysUseCase {
  private http: HttpKyClient;

  constructor(http: HttpKyClient) {
    this.http = http;
  }

  async execute(input: UseCaseInput): Promise<UseCaseOutput> {
    const { store_slug } = input;

    if (!store_slug) {
      throw new Error('Store slug is required');
    }

    const response = await this.http.sendRequest<UseCaseOutput, void>({
      endpoint: ENDPOINT(store_slug),
      method: HttpMethod.GET,
    });

    return response;
  }
}
